var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// Utils
import { css } from 'styled-components';
/**
 * @description Returns the required styles to set the size of an icon
 *              This will ensure both width and height of the icon are
 *              exactly the same resulting in a square
 *
 * @param {string} iconSize
 */
export var getSquareIconStyles = function (iconSize) { return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n"], ["\n  width: ", ";\n  height: ", ";\n"])), iconSize, iconSize); };
var templateObject_1;
//# sourceMappingURL=getSquareIconStyles.js.map